export const addCommas = (num: any) =>
  num?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
